module.exports = __webpack_public_path__ + "img/30_60.514a54a0.png";